import React, { useState, useEffect, ComponentPropsWithRef } from 'react'
import { animated, useSpring } from '@react-spring/web'

const FROM_STYLE = { opacity: 0.5, height: '100%' }
const TO_STYLE = { opacity: 1, height: '100%' }
const DURATION = 750

interface Props extends ComponentPropsWithRef<'div'> {
    active?: boolean
    className?: string
}
export const FadingWraper = (props: Props) => {
    const { className, children, active = false, style } = props
    const [toggled, toggle] = useState(false)
    useEffect(() => {
        if (!active) return
        const val = setInterval(() => {
            toggle((t) => !t)
        }, DURATION)
        return () => clearInterval(val)
    }, [active])

    const styles = useSpring({
        from: !active ? TO_STYLE : toggled ? FROM_STYLE : TO_STYLE,
        to: !active ? TO_STYLE : toggled ? TO_STYLE : FROM_STYLE,
        config: {
            duration: DURATION,
        },
    })

    const AnimatedDiv = animated.div as React.FC<{
        style?: Record<string, unknown>
        children?: React.ReactNode
    }>
    return (
        <div style={style} className={className}>
            <AnimatedDiv style={styles}>{children}</AnimatedDiv>
        </div>
    )
}
